import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Protocol17025Cat_Interface,Empty_Protocol17025Cat_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Cat_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { Protocol17025CatService } from 'src/app/Service/Protocol17025/Protocol17025Cat.service';

@Component({
  selector: 'app-Protocol17025Cat_Check',
  templateUrl: './Protocol17025Cat_Check.component.html',
  styleUrls: ['./Protocol17025Cat_Check.component.scss']
})
export class Protocol17025Cat_CheckComponent implements OnInit {

  @Input() DataList_Protocol17025Cat:Array<Protocol17025Cat_Interface>=[]
  @Input() Selected_Protocol17025Cat:Array<Protocol17025Cat_Interface>=[]
  @Output() On_Get_Selected_Tag = new EventEmitter<Array<Protocol17025Cat_Interface>>();
  Procssing:boolean=false


  constructor(
    private Protocol17025Cat_Service:Protocol17025CatService,
    private Alertify_Service:AlertifyService,
    private modalService: BsModalService
  ) { }




  ngOnInit() {
  }


  OnGet_Change_Action(input: Protocol17025Cat_Interface) {
    input.childVisible=!input.childVisible
    var IsItDelete:boolean=false
    for (let item of this.Selected_Protocol17025Cat)
    {
      if (input.id == item.id)
      {
        var temp = this.Selected_Protocol17025Cat.indexOf(item)
        this.Selected_Protocol17025Cat.splice(temp, 1)
        IsItDelete=true
        break;
      }
    }

    if (IsItDelete == false)
      this.Selected_Protocol17025Cat.push(input)

      this.On_Get_Selected_Tag.emit(this.Selected_Protocol17025Cat);
  }


}
